import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import { buildThumbnailUrl } from '@bd/bdcore-utilities';

const styles = css`
  background-size: cover;
  background-position: center center;
  height: 40vh;
  width: 100%;
  padding: 0 0 0 0;
  text-align: center;
  position: relative;
  @media (min-width: 992px) {
    height: 75vh;
    margin: 0;
  }
`;

class ImageWrapper extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      headerImage: undefined,
    };
  }

  componentDidMount() {
    this.getHeaderImage();
  }

  getHeaderImage() {
    let { headerImage } = this.state;

    if (!headerImage) {
      headerImage = _.get(this.props.page, 'header_image');

      this.setState({
        headerImage: buildThumbnailUrl(_.get(headerImage, 'contentUrl'), { width: 2000, height: 2000 }),
      });
    }
  }

  render() {
    const { children } = this.props;
    const { headerImage } = this.state;
    return (
      <div
        className={styles}
        style={headerImage ? { backgroundImage: `url('${headerImage}')` } : undefined}
      >
        {children}
      </div>
    );
  }
}

ImageWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  page: PropTypes.object.isRequired,
};

export default ImageWrapper;



// WEBPACK FOOTER //
// ./src/pages/IndexPage/ImageWrapper.js